$(function()
{

	// Only allow number input
	$(el('edtVoucherValue')).on('keydown', function(e){
		var iValue = $(this).val();
		if(e.keyCode == 8 || ((isNaturalNumber(iValue) || iValue == '') && e.keyCode != 69 && e.keyCode != 109 && e.keyCode != 189 && e.keyCode != 107 )){
			return;
		}
		else{
			e.preventDefault();
		}
	});

	// Update preview
	$(el('edtVoucherValue')).on('keyup change', function(e){
		var iValue = $(this).val();
		if(iValue > 9999)
		{
			$(this).val(9999);
			$(el('valueOverlay')).find('.value').text(9999);
		}
		else
		{
			$(el('valueOverlay')).find('.value').text(iValue);
		}
	});

	$(el('mainContainer')).on('click', '#btnOrderVoucher', function()
	{
		addVoucher();
		return false;
	});

	$('.giftvoucherWrapper').on('click', '.voucherImage', function()
	{
		$(el('voucherImage')).find('img').attr('src',$(this).data('url'));
		$(el('edtVoucherImage')).val($(this).data('name'));
	});

	$('.giftvoucherWrapper').on('keyup', '#edtVoucherValue', function()
	{
		$(el('voucherImage')).find('.voucherAmountWrapper .amount').text($(this).val().toString());
	});

	$('.giftvoucherWrapper').on('keyup', '#edtVoucherText', function()
	{
		$(this).val($(this).val().substring(0,280));

		var charCount = parseInt($(this).val().length);
		$(el('frmVoucher')).find('.charCount').html(charCount);
		$(el('voucherImage')).find('.voucherTextWrapper').text($(this).val().toString());
	});

	init();
});

function addVoucher()
{
	var bValid = validateForm($(el('frmVoucher')));

	if(bValid)
	{
		var bWishlist = (typeof sCurrentModule !== "undefined" && sCurrentModule == "wishlist");
		var sParams = getValues($(el('frmVoucher')));

		if (bWishlist)
		{
			sParams += '&id=' + sWishlistId + '&edtVoucherImage=' + sVoucherImage;
		}

		uAjax = (bWishlist) ? "/index.cfm/wishlist/ajax/addegiftvoucher" : "/index.cfm/product/ajax/addegiftvoucher";
		var oCall = callAjax("addegiftvoucher", sParams, "post");
		// process feedback
		oCall.success(function(oData)
		{
			if(oData.ErrorType === '')
			{
				if(bWishlist)
				{
					(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
					ciResponsive.process();
				}
				else
				{
					window.location = '/transaction';
				}
			}
			else
			{
				// show error message
				showAlert('error', oData.ErrorMessage, oData.ErrorUnhandled);
			}
		});
	}
}

function init()
{
	$('.voucherImages').find('.voucherImage:first').trigger('click');
}

function isNaturalNumber(n) {
	n = n.toString(); // force the value incase it is not
	var n1 = Math.abs(n),
		n2 = parseInt(n, 10);
	return !isNaN(n1) && n2 === n1 && n1.toString() === n;
}